import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App'; 
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';


const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
